import {Grid} from "@mui/material";
import * as React from "react";
import DriverDetails from "./DriverDetails";
import RentalAgreement from "./RentalAgreement";
import GPSDetails from "./GPSDetails";
import CustomerDetails from "./CustomerDetails";
import VehicleDetails from "./VehicleDetails";
import {useEffect, useState} from "react";
import {useTheftMisappropriationActions} from "../../../../service/useTheftMisappropriationActions";

const TabCustomerRADetails = (props: any) => {
    const  id = props.id;
    const  {rentalAgreement, plate, tenant} = props;
    const {getRentalAgreementById, getVehicleDetailsByPlate} = useTheftMisappropriationActions();
    const [vehicleObject, setVehicleObject] = useState(null);
    const [customerDetailsObject, setCustomerDetailsObject] = useState(null);
    const [customerAndRADetails, setCustomerAndRADetails] = useState(null);
    const [driverDetailsObject, setDriverDetailsObject] = useState(null);
    const [additionalDriverDetailsObject, setAdditionalDriverDetailsObject] = useState(null);

    useEffect(() => {
        if (rentalAgreement) {
            getRentalAgreementById(rentalAgreement).then(res => {
                if (res) {
                    setCustomerDetailsObject(res.raOwner);
                    setCustomerAndRADetails(res);
                    setDriverDetailsObject(res.raOwner);
                    setAdditionalDriverDetailsObject(res.firstDriver);

                    if (res.vehicle && res.vehicle.plate && res.vehicle.plate.code) {
                        getVehicleDetailsByPlate(res.vehicle.plate.code, {tenant: res.idTenant}).then(res => {
                            setVehicleObject(res);
                        })

                    }
                }

            });
        } else if (!!plate) {
            getVehicleDetailsByPlate(plate, {tenant: tenant})
                .then((res: any)=> {
                    setVehicleObject(res);
                })
        }
    }, [rentalAgreement]);


    return (
        <Grid container columnSpacing={3} rowSpacing={1}>

            <Grid item xs={12}>
                <VehicleDetails vehicle={vehicleObject}/>
            </Grid>
            <Grid item xs={12}>
                <GPSDetails vehicle={vehicleObject}/>
            </Grid>
            <Grid item xs={12}>
                <RentalAgreement customerAndRADetails={customerAndRADetails}/>
            </Grid>
            <Grid item xs={12}>
                <CustomerDetails customerDetailsObject={customerDetailsObject} id={id}/>
            </Grid>
            <Grid item xs={12}>
                <DriverDetails driverDetailsObject={driverDetailsObject}
                               additionalDriverDetailsObject={additionalDriverDetailsObject} id={id}/>
            </Grid>
        </Grid>
    );
}

export default TabCustomerRADetails;